// extracted by mini-css-extract-plugin
export default {"Home":"Home_Home__PduFw","pulse":"Home_pulse__ANQLn"};